// Record pages: the pure half of views/record_panels.jsx (record-page redesign 4a).
// No JSX, DOM, location, history or storage: test/record_panels.test.mjs runs this file in node:vm.
(function () {
  const own = (o, k) => o != null && Object.prototype.hasOwnProperty.call(o, k);
  const freezeDeep = (o) => {
    Object.keys(o).forEach((k) => { const v = o[k]; if (v && typeof v === 'object' && !Object.isFrozen(v)) freezeDeep(v); });
    return Object.freeze(o);
  };
  const empty = (v) => v == null || v === '';

  const KINDS = ['deal', 'company', 'contact'];
  const ROUTE_OF = { deal: 'deals', company: 'companies', contact: 'people' };
  const KIND_OF_ROUTE = { deals: 'deal', companies: 'company', people: 'contact' };
  const OBJECT_TYPE = { deal: 'engagement', company: 'company', contact: 'contact' };
  const PANEL_KEYS = ['panel', 'tab', 'folder', 'file', 'focus', 'status', 'call', 'src', 'run', 'field'];
  const NOTE_KEYS = ['note'];
  const PARAM_KEYS = PANEL_KEYS.concat(NOTE_KEYS);
  const STATE_FLAG = 'atlasPanel';
  const STATE_REC = 'atlasRec';
  const EVT_PARAMS = 'atlas-record-params';
  const EVT_LAYOUT = 'atlas-layout';
  const RECORD_V2_KEY = 'atlas.recordV2';   // the pre-switch ⌘K toggle (anyone's): dropped on load, never read
  const RECORD_V2_DEFAULT = true;
  const RECORD_TEAM_KEY = 'atlas.recordTeamLayout';
  const RECORD_PREVIEW_KEY = 'atlas.recordPreview';
  const RECORD_LAYOUTS = ['v2', 'classic'];

  const ws = (kinds, guest, maxWidth, keys, title) => ({ form: 'workspace', kinds, guest, write: false, maxWidth, keys, title });
  const dr = (kinds, guest, width, keys, title) => ({ form: 'drawer', kinds, guest, write: false, width, keys, title });
  const PANEL_META = {
    buyers:    ws(['deal'], true, 1600, ['tab', 'status', 'focus'], 'Buyers'),
    market:    ws(KINDS, false, 1480, ['tab'], 'Market'),
    vault:     ws(['deal', 'company'], false, 1480, ['folder', 'file'], 'Data vault'),
    files:     ws(['deal', 'company'], true, 1480, ['status'], 'Files'),
    firm:      ws(['company'], false, 1480, ['tab'], 'Firm'),
    details:   dr(KINDS, true, 480, [], 'All details'),
    people:    dr(KINDS, false, 420, [], 'People'),
    history:   dr(KINDS, true, 560, ['tab'], 'History'),
    intel:     dr(KINDS, true, 640, ['focus'], 'Company intel'),
    ownership: dr(['deal', 'company'], false, 560, [], 'Ownership & acquisition'),
    marketing: dr(['company'], false, 640, [], 'Marketing materials'),
    myexit:    dr(['company'], false, 480, [], 'MyExit'),
    programs:  dr(['contact'], false, 600, ['tab'], 'Programs'),
    outreach:  dr(['contact'], false, 640, [], 'Outreach history'),
    calls:     dr(KINDS, true, 720, ['call'], 'Meetings & calls'),
    research:  dr(KINDS, false, 560, ['src', 'run', 'field'], 'Research run'),
  };
  const RESEARCH_SOURCES = {
    field:     { kinds: ['deal', 'company', 'contact'], needs: 'run' },
    fill:      { kinds: ['company'], needs: 'field' },
    ownership: { kinds: ['company', 'deal', 'contact'], needs: null },
    tier:      { kinds: ['company', 'deal', 'contact'], needs: null },
    industry:  { kinds: ['company', 'deal', 'contact'], needs: 'run' },
  };
  const PANE_DEFAULTS = { deal: { L: 288, R: 300 }, company: { L: 360, R: 360 }, contact: { L: 300, R: 300 } };
  const FIT = { centerMin: 420, sideMin: 240, sideMax: 440, scrollBelow: 900, sidebar: 220 };
  const Z = { drawer: 50, workspace: 55, modal: 60, stacked: 70, menu: 400, layerStep: 15 };
  const ALIASES = {
    deal: [{ match: { tab: 'outreach' }, absent: ['panel'], add: { panel: 'buyers' }, requires: { surface: 'v2', panel: 'buyers' } }],
    company: [], contact: [],
  };

  // ── query + hash
  const dec = (s) => { const t = String(s).replace(/\+/g, ' '); try { return decodeURIComponent(t); } catch (_) { return t; } };
  const enc = (s) => encodeURIComponent(String(s));
  const parseQuery = (qs) => {
    const out = {};
    String(qs == null ? '' : qs).replace(/^\?/, '').split('&').forEach((pair) => {
      const i = pair.indexOf('=');
      if (i <= 0) return;                         // no key, or a bare key (an empty value)
      const k = dec(pair.slice(0, i));
      if (!k || k === '__proto__') return;
      const v = dec(pair.slice(i + 1));
      if (v === '') delete out[k]; else out[k] = v;   // a repeated key keeps its last value
    });
    return out;
  };
  const buildQuery = (params) => {
    if (!params) return '';
    const parts = [];
    const put = (k) => { const v = params[k]; if (!empty(v)) parts.push(enc(k) + '=' + enc(v)); };
    PARAM_KEYS.forEach((k) => { if (own(params, k)) put(k); });
    Object.keys(params).forEach((k) => { if (!PARAM_KEYS.includes(k)) put(k); });
    return parts.join('&');
  };
  const parseRecordHash = (hash) => {
    let h = String(hash == null ? '' : hash);
    if (h[0] === '#') h = h.slice(1);
    if (h[0] !== '/' || h.includes('access_token=')) return null;   // same guard as router.jsx
    const qi = h.indexOf('?');
    const parts = (qi === -1 ? h : h.slice(0, qi)).slice(1).split('/');
    const route = parts[0]; const rawId = parts[1];
    if (!own(KIND_OF_ROUTE, route) || !rawId) return null;
    let id; try { id = decodeURIComponent(rawId); } catch (_) { id = rawId; }
    return { kind: KIND_OF_ROUTE[route], route, id, params: parseQuery(qi === -1 ? '' : h.slice(qi + 1)) };
  };
  const buildRecordHash = (kind, id, params) => {
    if (!own(ROUTE_OF, kind)) return '';
    const q = buildQuery(params);
    return '#/' + ROUTE_OF[kind] + '/' + encodeURIComponent(String(id)) + (q ? '?' + q : '');
  };
  // The record's head exactly as the URL spells it (case, escapes), with a new query.
  const hashWithParams = (hash, params) => {
    const head = String(hash == null ? '' : hash).split('?')[0];
    const q = buildQuery(params);
    return (head[0] === '#' ? head : '#' + head) + (q ? '?' + q : '');
  };
  const normId = (id) => String(id).toLowerCase();             // record ids are UUIDs (case-blind) or digits
  const recKey = (rec) => `${rec.kind}:${normId(rec.id)}`;
  const sameRecord = (a, b) => !!a && !!b && !!a.kind && a.kind === b.kind
    && !empty(a.id) && !empty(b.id) && normId(a.id) === normId(b.id);
  const mergeParams = (cur, patch) => {
    const next = Object.assign({}, cur || {});
    Object.keys(patch || {}).forEach((k) => {
      if (k === '__proto__') return;
      const v = patch[k];
      if (empty(v)) delete next[k]; else next[k] = String(v);
    });
    return next;
  };
  const dropKeys = (params, keys) => {
    const next = Object.assign({}, params || {});
    (keys || []).forEach((k) => { delete next[k]; });
    return next;
  };
  const hasPopout = (params) => !!(params && (params.panel || params.note));
  const panelMeta = (name) => (typeof name === 'string' && own(PANEL_META, name) ? PANEL_META[name] : null);
  const cleanPanelParams = (name, params) => {
    const meta = panelMeta(name);
    if (!meta) return Object.assign({}, params || {});
    const out = {};
    meta.keys.forEach((k) => { if (params && !empty(params[k])) out[k] = String(params[k]); });
    return out;
  };
  const openPatch = (name, params) => {               // open() semantics: every panel key cleared, note kept
    const patch = {};
    PANEL_KEYS.forEach((k) => { patch[k] = null; });
    const clean = cleanPanelParams(name, params || {});
    Object.keys(clean).forEach((k) => { if (k !== 'panel' && PANEL_KEYS.includes(k)) patch[k] = clean[k]; });
    patch.panel = name;
    return patch;
  };
  const linkParams = (params) => {                    // a link's query: known keys with string/number values only
    if (!params || typeof params !== 'object' || Array.isArray(params)) return null;
    const out = {}; let n = 0;
    PARAM_KEYS.forEach((k) => {
      if (!own(params, k)) return;
      const v = params[k];
      if ((typeof v === 'string' && v !== '') || (typeof v === 'number' && Number.isFinite(v))) { out[k] = String(v); n += 1; }
    });
    return n ? out : null;
  };
  const sameParams = (a, b) => {
    const keys = (p) => Object.keys(p || {}).filter((k) => !empty(p[k])).sort();
    const ka = keys(a); const kb = keys(b);
    return ka.length === kb.length && ka.every((k, i) => k === kb[i] && String(a[k]) === String(b[k]));
  };

  // ── history (contract §4): one pushed entry per pop-out session
  const planWrite = (cur, next, state, key) => {
    if (sameParams(cur, next)) return { method: 'none' };
    const had = hasPopout(cur); const has = hasPopout(next);
    const ours = !!(state && state[STATE_FLAG] && state[STATE_REC] === key);
    if (!had && has) return { method: 'push', state: { [STATE_FLAG]: 1, [STATE_REC]: key } };
    if (had && !has && ours) return { method: 'back' };
    return { method: 'replace', state: state === undefined ? null : state };
  };

  // ── aliases (contract §6): inert unless ctx says so
  const applyAliases = (kind, params, ctx) => {
    const list = own(ALIASES, kind) ? ALIASES[kind] : [];
    const c = ctx || {};
    let p = params || {}; let changed = false;
    list.forEach((a) => {
      if (!Object.keys(a.match).every((k) => p[k] === a.match[k])) return;
      if ((a.absent || []).some((k) => !empty(p[k]))) return;
      const req = a.requires || {};
      if (req.surface && c.surface !== req.surface) return;
      if (req.panel && !(typeof c.available === 'function' && c.available(req.panel))) return;
      p = mergeParams(p, a.add); changed = true;
    });
    return { params: p, changed };
  };

  // ── gate (contract §8.6)
  const gatePanel = (input) => {
    const o = input || {};
    if (!o.name) return 'ok';
    if (!o.meta || !(o.meta.kinds || []).includes(o.kind)) return 'strip';
    if (o.guest && !o.meta.guest) return 'strip';
    if (!o.host) return 'strip';
    if (o.valid === false) return 'strip';
    if (o.meta.write) { if (o.canWrite == null) return 'wait'; if (!o.canWrite) return 'strip'; }
    if (o.applies == null) return 'wait';
    return o.applies ? 'ok' : 'strip';
  };
  const validResearchParams = (kind, params) => {
    const p = params || {};
    const s = typeof p.src === 'string' && own(RESEARCH_SOURCES, p.src) ? RESEARCH_SOURCES[p.src] : null;
    if (!s || !s.kinds.includes(kind)) return false;
    if (!empty(p.run) && !/^\S{1,64}$/.test(String(p.run))) return false;
    if (!empty(p.field) && !/^[a-z][a-z0-9_]{0,63}$/.test(String(p.field))) return false;
    if (s.needs === 'run' && empty(p.run)) return false;
    if (s.needs === 'field' && empty(p.field)) return false;
    return true;
  };

  // ── vault (VaultManager keys ⇄ URL values)
  const vaultFolderToParam = (key) => {
    if (empty(key) || key === '__all') return 'all';
    if (key === '__room') return 'room';
    if (key === '__attachments') return 'attachments';
    const s = String(key);
    return s.endsWith('::ready') ? s.slice(0, -7) + '.ready' : s;
  };
  const vaultParamToFolder = (param) => {
    if (empty(param)) return null;
    const s = String(param);
    if (s === 'all') return '__all';
    if (s === 'room') return '__room';
    if (s === 'attachments') return '__attachments';    // All attachments: FilesPanel's list for the record
    return s.endsWith('.ready') ? s.slice(0, -6) + '::ready' : s;
  };
  // ?file= is a vault file's attachment id (a UUID): the canonical id, or null.
  // Trailing junk a chat client glued onto a pasted link ('.', ')') is dropped;
  // more hex or dashes after the id is a different id, so null.
  const FILE_ID_RE = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?![0-9a-f-])/i;
  const vaultFileParam = (param) => {
    const m = typeof param === 'string' ? FILE_ID_RE.exec(param) : null;
    return m ? m[1].toLowerCase() : null;
  };
  // The folder a link to a file opens at: the asked one when the file is in it
  // (or it is All files), else All files. `loc` is the file's location key.
  const vaultFileFolder = (key, loc) => (key === '__all' || (!empty(key) && key === loc) ? key : '__all');
  // Where a phone page's "Files" row goes (step 15): the vault's All attachments on a
  // seller deal with a company and on a seller company (the vault is mounted there);
  // the Files workspace on shells, guests, a company-less deal, firms and non-sellers;
  // null while a company's variant isn't known yet. Mirrors the vault / files applies().
  const ATTACH = Object.freeze({ name: 'vault', params: Object.freeze({ folder: 'attachments' }) });
  const FILES = Object.freeze({ name: 'files', params: Object.freeze({}) });
  const filesPanelFor = (kind, facts, opts) => {
    const f = facts || {};
    if (kind === 'deal') return (opts && opts.guest) || f.shell || !f.companyId ? FILES : ATTACH;
    if (kind === 'company') return !f.known ? null : f.sellerCompany ? ATTACH : FILES;
    return null;
  };

  // ── layers + layout flag (consumed from 4b; the team switch since 2026-10-22)
  const layerZ = (ownZ, zBase) => (zBase ? Math.max(ownZ, zBase + Z.layerStep) : ownZ);
  // The record layout rule (the team switch, 2026-10-22) → true for the new layout.
  // team: whoami.record_layout (null until whoami answers, or when it fails or
  // sends none). admin: whoami's role is admin (null = not known yet).
  // preview: an admin's ⌘K preview (atlas.recordPreview, 'v2' | 'classic'; only
  // written once whoami says admin, so the pre-switch atlas.recordV2 never counts).
  // remembered: the last team layout this browser saw (atlas.recordTeamLayout).
  // A preview counts unless whoami says "not an admin"; then the team's
  // layout, else the remembered one, else dflt (RECORD_V2_DEFAULT).
  const resolveRecordV2 = (o) => {
    const x = o || {};
    if (RECORD_LAYOUTS.includes(x.preview) && x.admin !== false) return x.preview === 'v2';
    if (RECORD_LAYOUTS.includes(x.team)) return x.team === 'v2';
    if (RECORD_LAYOUTS.includes(x.remembered)) return x.remembered === 'v2';
    return !!x.dflt;
  };
  // The two stored inputs, never throwing; anything unknown reads as null.
  const readRecordPrefs = (getItem) => {
    const read = (k) => { try { const v = getItem(k); return RECORD_LAYOUTS.includes(v) ? v : null; } catch (_) { return null; } };
    return { preview: read(RECORD_PREVIEW_KEY), remembered: read(RECORD_TEAM_KEY) };
  };

  // ── widths (consumed in step 9): saved widths are never changed, only fitted
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
  const fitRecordColumns = (o) => {
    const x = o || {};
    const centerMin = x.centerMin != null ? x.centerMin : FIT.centerMin;
    const sideMin = x.sideMin != null ? x.sideMin : FIT.sideMin;
    const sideMax = x.sideMax != null ? x.sideMax : FIT.sideMax;
    const scrollBelow = x.scrollBelow != null ? x.scrollBelow : FIT.scrollBelow;
    const bodyW = Number.isFinite(x.bodyW) ? x.bodyW : 0;
    const W = Math.max(bodyW, scrollBelow);
    const scroll = bodyW < scrollBelow;
    let l = clamp(Number.isFinite(x.L) ? x.L : sideMin, sideMin, sideMax);
    let r = clamp(Number.isFinite(x.R) ? x.R : sideMin, sideMin, sideMax);
    const deficit = centerMin - (W - l - r);
    if (deficit > 0) {
      const exL = l - sideMin; const exR = r - sideMin; const room = exL + exR;
      if (room > 0) {
        const take = Math.min(deficit, room);
        const sL = Math.round(take * exL / room);
        l -= sL; r -= take - sL;
      }
    }
    return { L: l, C: W - l - r, R: r, minWidth: W, scroll };
  };

  // ── record page shell (step 9: views/record_page.jsx; the numbers are docs "## Shell")
  const SHELL = {
    row1: 44, strip: 40, compactAt: 48, expandAt: 8, fade: 0.18,
    tabletThree: 1120, tabletTwo: 720, tabletCenter: 460, twoSide: 320,
    composerMin: 240, composerShare: 0.55, composerGap: 120, floatW: 760, floatInset: 12,
  };
  const PANES_KEY = 'atlas.recordPanes.';    // + kind → { L, R }; + kind + '.collapsed' → { left, right }
  const DEAL_PANES_KEY = 'atlas.dealPanes';  // the classic deal widths { left, right }: seeds PANES_KEY + 'deal' once
  const NO_SIDES = { left: false, right: false };
  const TOUCH_KIND_LABEL = { note: 'Note', email: 'Email', call: 'Call', meeting: 'Meeting' };
  const finite = (v) => typeof v === 'number' && Number.isFinite(v);
  const sideW = (v) => clamp(Math.round(v), FIT.sideMin, FIT.sideMax);
  const paneDefaults = (kind) => (own(PANE_DEFAULTS, kind) ? PANE_DEFAULTS[kind] : PANE_DEFAULTS.deal);
  const parseObj = (raw) => {
    if (typeof raw !== 'string' || raw === '') return null;
    try { const v = JSON.parse(raw); return v && typeof v === 'object' && !Array.isArray(v) ? v : null; } catch (_) { return null; }
  };

  // Touch tablets: three columns at ≥1120 (sides capped), two at 720–1119, one below.
  const tabletRecordLayout = (bodyW) => {
    const w = finite(bodyW) ? bodyW : 0;
    const mode = w >= SHELL.tabletThree ? 'three' : w >= SHELL.tabletTwo ? 'two' : 'one';
    return { mode, sideCap: Math.max(0, Math.floor((w - SHELL.tabletCenter) / 2)) };
  };
  // Compact above 48px of center scroll, back below 8 (no flip-flop on a short feed).
  const headerCompactNext = (compact, scrollTop) => {
    if (!finite(scrollTop)) return !!compact;
    return compact ? scrollTop >= SHELL.expandAt : scrollTop > SHELL.compactAt;
  };
  // Raw storage strings in, never storage itself.
  const readPaneWidths = (raw, kind) => {
    const d = paneDefaults(kind); const o = parseObj(raw) || {};
    return { L: finite(o.L) ? sideW(o.L) : d.L, R: finite(o.R) ? sideW(o.R) : d.R };
  };
  const readPaneCollapsed = (raw) => { const o = parseObj(raw) || {}; return { left: o.left === true, right: o.right === true }; };
  const migrateDealPanes = (raw) => {
    const o = parseObj(raw);
    if (!o || !finite(o.left) || !finite(o.right)) return null;
    return { L: sideW(o.left), R: sideW(o.right) };
  };
  // What the grid does at this body width on this device. 'desk' = mouse (dividers,
  // fitRecordColumns, sideways scroll below 900); 'three' | 'two' | 'one' = touch.
  const recordGridPlan = (o) => {
    const x = o || {};
    const bodyW = finite(x.bodyW) ? Math.max(0, x.bodyW) : 0;
    const d = paneDefaults(x.kind);
    const c = x.collapsed || {};
    if (x.touch) {
      const t = tabletRecordLayout(bodyW);
      if (t.mode === 'two') {
        return { mode: 'two', L: 0, C: Math.max(0, bodyW - SHELL.twoSide), R: SHELL.twoSide, minWidth: 0, scroll: false, dividers: false, collapsed: NO_SIDES };
      }
      if (t.mode === 'one') return { mode: 'one', L: 0, C: bodyW, R: 0, minWidth: 0, scroll: false, dividers: false, collapsed: NO_SIDES };
      const col = { left: !!c.left, right: !!c.right };
      const l = col.left ? SHELL.strip : Math.min(d.L, t.sideCap);
      const r = col.right ? SHELL.strip : Math.min(d.R, t.sideCap);
      return { mode: 'three', L: l, C: bodyW - l - r, R: r, minWidth: 0, scroll: false, dividers: false, collapsed: col };
    }
    const w = x.widths || d;
    const col = { left: !!c.left, right: !!c.right };
    if (!col.left && !col.right) {
      const f = fitRecordColumns({ bodyW, L: w.L, R: w.R });
      return { mode: 'desk', L: f.L, C: f.C, R: f.R, minWidth: f.minWidth, scroll: f.scroll, dividers: true, collapsed: col };
    }
    // A 40px strip leaves ≥ 420 for the center at any width ≥ 900 (900 − 40 − 440), so no shrink.
    const W = Math.max(bodyW, FIT.scrollBelow);
    const l = col.left ? SHELL.strip : sideW(finite(w.L) ? w.L : FIT.sideMin);
    const r = col.right ? SHELL.strip : sideW(finite(w.R) ? w.R : FIT.sideMin);
    return { mode: 'desk', L: l, C: W - l - r, R: r, minWidth: W, scroll: bodyW < FIT.scrollBelow, dividers: true, collapsed: col };
  };
  // Every style that changes across modes. Every scroller owns height 100% (or the
  // body's height) + overflowY auto; the DOM never changes, only these.
  const LINE = '1px solid var(--border)';
  const recordShellStyles = (plan, m) => {
    const p = plan || {}; const x = m || {};
    const top = Math.max(0, Math.round(finite(x.overlayH) ? x.overlayH : 0));
    const act = { gridArea: 'act', minWidth: 0, padding: '14px 16px 0' };
    const feed = { gridArea: 'feed', minWidth: 0, padding: '14px 16px 16px' };
    const scroller = { flex: 1, minHeight: 0, position: 'relative', overflowX: 'hidden', overflowY: 'auto', WebkitOverflowScrolling: 'touch' };
    if (p.mode === 'two') {
      return {
        mode: 'two', act, feed, body: scroller,
        grid: { display: 'grid', position: 'relative', minHeight: '100%', gridTemplateColumns: `minmax(0, 1fr) ${p.R}px`,
          gridTemplateRows: 'auto 1fr', gridTemplateAreas: '"center facts" "center cards"' },
        left: { gridArea: 'facts', minWidth: 0, borderLeft: LINE, background: 'var(--surface)' },
        center: { gridArea: 'center', position: 'sticky', top: 0, alignSelf: 'start', height: finite(x.bodyH) && x.bodyH > 0 ? x.bodyH : '100%',
          overflowY: 'auto', overscrollBehavior: 'contain', minWidth: 0, background: 'var(--surface-2)', WebkitOverflowScrolling: 'touch' },
        right: { gridArea: 'cards', minWidth: 0, borderLeft: LINE, borderTop: LINE, background: 'var(--surface)' },
        spacer: { left: top, center: top, right: 0 },
      };
    }
    if (p.mode === 'one') {
      return {
        mode: 'one', act, feed, body: scroller,
        grid: { display: 'grid', position: 'relative', gridTemplateColumns: 'minmax(0, 1fr)', alignContent: 'start',
          gridTemplateAreas: '"spacer" "act" "facts" "feed" "cards"', background: 'var(--surface-2)' },
        left: { gridArea: 'facts', minWidth: 0, borderTop: LINE, borderBottom: LINE, background: 'var(--surface)' },
        center: { display: 'contents' },
        right: { gridArea: 'cards', minWidth: 0, borderTop: LINE, background: 'var(--surface)' },
        spacer: { left: 0, center: top, right: 0 },
      };
    }
    const pane = { height: '100%', overflowY: 'auto', minWidth: 0 };
    return {
      mode: p.mode || 'desk', act, feed,
      body: { flex: 1, minHeight: 0, position: 'relative', overflowX: p.scroll ? 'auto' : 'hidden', overflowY: 'hidden' },
      grid: { display: 'grid', position: 'relative', height: '100%', minWidth: p.minWidth || 0,
        gridTemplateColumns: `${p.L}px minmax(${FIT.centerMin}px, 1fr) ${p.R}px` },
      left: { ...pane, borderRight: LINE, background: 'var(--surface)' },
      center: { ...pane, background: 'var(--surface-2)' },
      right: { ...pane, borderLeft: LINE, background: 'var(--surface)' },
      spacer: { left: top, center: top, right: top },
    };
  };
  // The composer pane: 55% of the column (≥ 240) until dragged; a drag keeps 120px of feed.
  const composerPaneHeight = (colH, dragged) => {
    const h = finite(colH) ? colH : 0;
    const max = Math.max(SHELL.composerMin, h - SHELL.composerGap);
    if (finite(dragged)) return Math.round(clamp(dragged, SHELL.composerMin, max));
    return Math.max(SHELL.composerMin, Math.round(h * SHELL.composerShare));
  };
  // ⤢: 760px (or the span − 16) centered over the center and right columns, kept 8px
  // inside the viewport (`viewW`): under a 900px body the grid scrolls sideways and the
  // right column can sit past the window's edge, with the float's Dock / Save on it.
  const composerFloatRect = (center, rightW, viewW) => {
    const c = center || {};
    const span = Math.max(0, (finite(c.width) ? c.width : 0) + (finite(rightW) ? rightW : 0));
    const vw = finite(viewW) && viewW > 0 ? viewW : null;
    const width = Math.max(0, Math.min(SHELL.floatW, span - 16, vw == null ? Infinity : vw - 16));
    const left = (finite(c.left) ? c.left : 0) + (span - width) / 2;
    return {
      left: Math.round(vw == null ? left : clamp(left, 8, Math.max(8, vw - width - 8))),
      top: Math.round((finite(c.top) ? c.top : 0) + SHELL.floatInset),
      width: Math.round(width),
      height: Math.max(SHELL.composerMin, Math.round((finite(c.height) ? c.height : 0) - 2 * SHELL.floatInset)),
    };
  };
  // ── divider drag (mouse), in display space so the divider tracks the pointer. It
  // starts from what is shown (auto-fit may be shrinking both sides): the dragged side
  // runs 240–440 and stops where the center would drop under 420; the other side holds
  // still. `keep` is what the other side saves on release: its saved width, or its shown
  // width while auto-fit was shrinking it (so nothing moves on release); a folded side
  // keeps its saved width, never its 40px strip.
  const dividerDragStart = (plan, saved, side) => {
    const p = plan || {}; const s = saved || {}; const c = p.collapsed || {};
    const left = side === 'left';
    const start = finite(left ? p.L : p.R) ? (left ? p.L : p.R) : FIT.sideMin;
    const other = finite(left ? p.R : p.L) ? (left ? p.R : p.L) : FIT.sideMin;
    const fitted = !c.left && !c.right && (p.L !== s.L || p.R !== s.R);
    const savedOther = finite(left ? s.R : s.L) ? (left ? s.R : s.L) : other;
    const W = Math.max(finite(p.minWidth) ? p.minWidth : 0, FIT.scrollBelow);
    return { side: left ? 'left' : 'right', start, keep: fitted ? other : savedOther,
      hi: clamp(W - other - FIT.centerMin, Math.max(FIT.sideMin, start), FIT.sideMax) };
  };
  // The dragged side's width `dx` px after the press (rightward is +, for either divider).
  const dividerDragWidth = (d, dx) => clamp(Math.round(d.start + (finite(dx) ? (d.side === 'left' ? dx : -dx) : 0)), FIT.sideMin, d.hi);
  // The widths a drag shows, and saves on release; null while the side is where it started.
  const dividerDragWidths = (d, w) => (!finite(w) || w === d.start ? null
    : d.side === 'left' ? { L: w, R: d.keep } : { L: d.keep, R: w });
  // 'Last touch 3d · Email · Jordan' (summary.last_touch = { at, kind, author, note_id }).
  const touchAge = (ms) => {
    const d = Math.floor(ms / 86400000);
    if (d < 1) return 'today';
    if (d < 60) return `${d}d`;
    if (d < 730) return `${Math.round(d / 30)}mo`;
    return `${Math.floor(d / 365)}y`;
  };
  const lastTouchText = (lt, nowMs) => {
    if (!lt || !lt.at) return null;
    const t = Date.parse(lt.at);
    if (!Number.isFinite(t)) return null;
    const now = finite(nowMs) ? nowMs : t;
    const parts = ['Last touch ' + touchAge(Math.max(0, now - t))];
    if (own(TOUCH_KIND_LABEL, lt.kind)) parts.push(TOUCH_KIND_LABEL[lt.kind]);
    const first = typeof lt.author === 'string' ? lt.author.trim().split(/\s+/)[0] : '';
    if (first) parts.push(first);
    return parts.join(' · ');
  };

  // ── notes (consumed in step 7; semantics pinned in test/record_panels.test.mjs)
  const draftKey = (kind, id) => `${kind}:${normId(id)}`;   // the same case-blind id as recKey
  // Seeded defaults (call_date = today, task.due = today) and a bare subtype don't count.
  const isDraftEmpty = (d) => {
    if (!d) return true;
    const t = (v) => (typeof v === 'string' ? v.trim() : '');
    const n = d.note || {}; const nx = d.next || {}; const tk = d.task || {};
    if (t(n.title) || t(n.body)) return false;
    if ((n.tag_companies || []).length || (n.tag_contacts || []).length) return false;
    if ((d.files || []).length) return false;
    if (nx.on && (t(nx.body) || nx.date)) return false;
    if (n.next_action_date && (d.kind === 'next_action' || n.dc_note_subtype === 'Next Action')) return false;
    if (t(tk.title) || t(tk.notes)) return false;
    return true;
  };
  // A Next Action written with a call/meeting (metadata.related_note_id) folds
  // under that note's card: removed from the list, attached as item.next.
  const pairNextActions = (items) => {
    if (!Array.isArray(items)) return items;
    const top = new Map();
    items.forEach((it, i) => { if (it && it.kind === 'note' && it.note && it.note.id != null) top.set(String(it.note.id), i); });
    const nextFor = new Map(); const removed = new Set();
    items.forEach((it, i) => {
      if (!it || it.kind !== 'note' || !it.note || it.note.dc_note_subtype !== 'Next Action') return;
      const rid = it.note.metadata && it.note.metadata.related_note_id;
      if (rid == null) return;
      const p = top.get(String(rid));
      if (p == null || p === i || nextFor.has(p) || removed.has(p) || nextFor.has(i)) return;
      nextFor.set(p, it.note); removed.add(i);
    });
    if (!removed.size) return items;
    const out = [];
    items.forEach((it, i) => { if (!removed.has(i)) out.push(nextFor.has(i) ? Object.assign({}, it, { next: nextFor.get(i) }) : it); });
    return out;
  };

  [ROUTE_OF, KIND_OF_ROUTE, OBJECT_TYPE, PANEL_META, RESEARCH_SOURCES, PANE_DEFAULTS, FIT, Z, ALIASES, SHELL, NO_SIDES, TOUCH_KIND_LABEL].forEach(freezeDeep);
  [KINDS, PANEL_KEYS, NOTE_KEYS, PARAM_KEYS, RECORD_LAYOUTS].forEach(Object.freeze);

  window.RecordPanelsCore = Object.freeze({
    KINDS, ROUTE_OF, KIND_OF_ROUTE, OBJECT_TYPE, PARAM_KEYS, PANEL_KEYS, NOTE_KEYS,
    STATE_FLAG, STATE_REC, EVT_PARAMS, EVT_LAYOUT, RECORD_V2_KEY, RECORD_V2_DEFAULT, RECORD_TEAM_KEY, RECORD_PREVIEW_KEY, RECORD_LAYOUTS,
    PANEL_META, RESEARCH_SOURCES, PANE_DEFAULTS, FIT, Z, ALIASES,
    parseQuery, buildQuery, parseRecordHash, buildRecordHash, hashWithParams, normId, recKey, sameRecord,
    mergeParams, dropKeys, hasPopout, panelMeta, cleanPanelParams, openPatch, linkParams, sameParams,
    planWrite, applyAliases, gatePanel, validResearchParams, vaultFolderToParam, vaultParamToFolder,
    vaultFileParam, vaultFileFolder, filesPanelFor,
    layerZ, resolveRecordV2, readRecordPrefs, fitRecordColumns, draftKey, isDraftEmpty, pairNextActions,
    SHELL, PANES_KEY, DEAL_PANES_KEY, tabletRecordLayout, headerCompactNext, readPaneWidths, readPaneCollapsed, migrateDealPanes, recordGridPlan, recordShellStyles, composerPaneHeight, composerFloatRect, lastTouchText,
    dividerDragStart, dividerDragWidth, dividerDragWidths,
  });
})();
